<template>
    <div class="liveList padding-20 bgc box-shadow">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="createLive()">创建直播</el-button>
            </div>
            <div class="search">
                <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                    <el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
                <el-input v-model.trim="param.subject" placeholder="输入直播活动名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="spackageName" label="直播名称" width="454px" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.logourl" alt="" v-if="scope.row.logourl ">
                            <img :src="defaultCover" alt="" v-else>
                            <div class="imageText-summary">
                                <p>{{scope.row.subject }}</p>
                                <p class="free" v-if="scope.row.feetype!=2">{{scope.row.feetype==1?'免费':'加密'}}</p>
                                <p class="free red" v-else>{{scope.row.saleprice}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="livepviewcount" label="观看量" class-name="center"></el-table-column>
                <el-table-column prop="rewardmoney" label="打赏金额(￥)" class-name="center" width="200"></el-table-column>
                <el-table-column prop="datetime" label="发布时间" class-name="center" width="200"></el-table-column>
                <el-table-column prop="" label="直播状态" class-name="center">
                    <template slot-scope="scope">
                        <span class="yellow" v-if="scope.row.status==0">{{scope.row.statusname}}</span>
                        <span class="blue" v-if="scope.row.status==1">{{scope.row.statusname}}</span>
                        <span class="gray" v-if="scope.row.status==10">{{scope.row.statusname}}</span>
                        <span class="gray" v-if="scope.row.status==100">{{scope.row.statusname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="240" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                        <span>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span>
                            <Share :row='scope.row'></Share>
                        </span>
                        <span>
                            <el-button @click="handlePlaySet(scope.row)" type="text" size="small">播放设置</el-button>
                            <span class="separator">|</span>
                        </span>
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                <el-button type="text" size="small">更多</el-button>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="handleGoLive(scope.row)" v-if="scope.row.status!=100&&scope.row.status!=10">去直播</el-dropdown-item>
                                <el-dropdown-item @click.native="handleEnd(scope.row)" v-if="scope.row.status==1">结束直播</el-dropdown-item>
                                <el-dropdown-item @click.native="handleToInfo(scope.row)">直播信息</el-dropdown-item>
                                <el-dropdown-item @click.native="handleAnchorSet(scope.row.liveid,scope.row.status)">主播设置</el-dropdown-item>
                                <el-dropdown-item @click.native="handleToComment(scope.row)">评论信息</el-dropdown-item>
                                <el-dropdown-item @click.native="handleToDel(scope.row)" v-if="scope.row.status!=100&&scope.row.status!=10">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
        <LiveTools ref="liveTools"></LiveTools>
        <AnchorSet ref="anchorSet"></AnchorSet>
    </div>
</template>

<script>
    import {getLiveEventList,deleteVliveEndStatus,updateVliveEndStatus} from 'api/vliveV2Api'
    import Page from 'base/page/page'
    import {mapGetters, mapActions} from 'vuex'
    import {vliveV2Code} from 'api/enumCode'
    import Share from '@/base/share/share'
    import {promiseUrlToQRCode} from 'common/js/tools'
    import LiveTools from '@/views/vliveV2/components/liveTools'
    import AnchorSet from '@/views/vliveV2/components/anchorSet'
    import {vliveMsg} from 'api/message'
    export default {
        name: 'LiveList',
        data() {
            return {
                defaultCover: require('@/common/images/vliveV2/noLive.png'),
                param:{
                    status:'',
                    subject:'',
                },
                statusList: vliveV2Code.status,
                total: 0,
                tableData: [],
            }
        },
        mounted(){
            this._getList()
        },
        methods:{
            //获取活动列表
            _getList(){
                this.setLoading(true)
                getLiveEventList({
                    data: Object.assign({}, this.param,this.page),
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                        this.tableData.forEach(obj => {
                            promiseUrlToQRCode(obj.shareurl, obj.logourl).then(
                                function(data) {
                                    obj.qrShare = data
                                },
                                function(reason, data) {
                                    console.log('二维码生成失败：', reason)
                                }
                            )
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //创建直播
            createLive(){
                this.$router.push({name: 'LiveEdit'})
            },
            handleQuery(){
                this.$refs.page.handleSizeChange(1)
            },
            //编辑
            handleEdit(row){
                this.$router.push({name: 'LiveEdit',query:{liveid:row.liveid}})
            },
            //播放设置
            handlePlaySet(row){
                this.$router.push({name: 'PlaySet',query:{liveid:row.liveid}})
            },
            //去直播
            handleGoLive(row){
                this.$refs.liveTools.open(row.liveid);
            },
            //结束直播
            handleEnd(row) {
                this.$prompt('<span class="tc-grey">' + vliveMsg.endVlive.msg + '</span>', vliveMsg.endVlive.title, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: vliveMsg.endVlive.confirmText,
                    cancelButtonText: vliveMsg.endVlive.cancelText
                }).then(({value}) => {
                    updateVliveEndStatus({
                        data: {
                            liveid: row.liveid,
                            verification:value
                        },
                        success: data => {
                            this.setLoading(false)
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.page.page=1
                            this._getList()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            //直播信息
            handleToInfo(row){
                this.$router.push({name: 'LiveInfo',query:{assetinnerid:row.liveid}})
            },
            //主播设置
            handleAnchorSet(id,status){
                this.$refs.anchorSet.open(id,status);
            },
            //评论信息
            handleToComment(row){
                this.$router.push({name: 'CommentList',query:{liveid:row.liveid}})
            },
            //删除
            handleToDel(row){
                this.$confirm(`确认删除该条直播吗？`, '提示', {
                }).then(() => {
                    this.setLoading(true)
                    let param={
                        liveid:row.liveid
                    }
                    deleteVliveEndStatus({
                        data: Object.assign({}, param),
                        success: data => {
                            this.setLoading(false)
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                            this._getList()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
                'permission',
                'shop'
            ])
        },
        components: {
            Page,Share,LiveTools,AnchorSet
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    @import "~common/scss/variable";
    .liveList{
        .filters input{
            height: 32px;
        }
        .imageText{
            display: flex;
            align-items: center;
            .imageText-summary{
                .free{
                    color: #409EFF;
                    font-size: 14px;
                }
                .red{
                    color: #F56C6C;
                }
            }
            img{
                width: 106px;
                height: 60px;
                margin-right: 10px;
            }
        }
        .result-list{
            .center{
                .cell{
                    text-align: center;
                }
            }
            .el-button+.el-button{
                margin-right: 20px;
            }
            .yellow{
                color: #E6A23C;
            }
            .blue{
                color: #409EFF;
            }
            .gray{
                color: #909399;
            }
        }
        .el-select-dropdown__list{
            text-align: center;
        }
    }
    .el-dropdown-menu__item,.el-select-dropdown__item{
        text-align: center;
    }
</style>
